<div class="cp-palhero" [class.cp-palhero-flush]="!showTiles" [class.cp-palhero-studio]="studio">

  <!-- Toolbar: title + how-generated subtitle + live count, and the global
       actions (Random scheme menu, From image, Copy). -->
  <div class="cp-palhero-bar">
    <div class="cp-palhero-head">
      <span class="cp-palhero-title">{{ title }}</span>
      <span class="cp-palhero-sub" [ngSwitch]="subtitle?.kind">
        <ng-container *ngSwitchCase="'theme'">
          <span class="cp-palhero-l1">Generated from Codigrate Themes</span>
          <span class="cp-palhero-l2">Source: <img class="cp-palhero-thumb cp-palhero-thumb-circle" [src]="subtitle?.logo" alt="" aria-hidden="true"/> <a *ngIf="subtitle?.themeHref" class="cp-palhero-em cp-palhero-link" [href]="subtitle?.themeHref" target="_blank" rel="noopener">{{ subtitle?.themeName }}</a><span *ngIf="!subtitle?.themeHref" class="cp-palhero-em">{{ subtitle?.themeName }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'image'">
          <span class="cp-palhero-l1">Generated from an uploaded image</span>
          <span class="cp-palhero-l2">Source: <img class="cp-palhero-thumb" [src]="subtitle?.imageSrc" alt="" aria-hidden="true"/> <span class="cp-palhero-em">{{ imageNameDisplay }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'harmony'">
          <span class="cp-palhero-l1">Generated {{ schemeArticle }} {{ subtitle?.scheme }} palette</span>
          <span class="cp-palhero-l2">Source: <span class="cp-palhero-dot" [style.background-color]="subtitle?.color"></span><a *ngIf="subtitle?.colorHref" class="cp-palhero-em cp-palhero-link" [href]="subtitle?.colorHref" target="_blank" rel="noopener">{{ subtitle?.name }}</a><span *ngIf="!subtitle?.colorHref" class="cp-palhero-em">{{ subtitle?.name }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'full'">
          <span class="cp-palhero-l1">Generated a random palette</span>
          <span class="cp-palhero-l2">Source: <span class="cp-palhero-em">{{ subtitle?.seed ? 'seed-' + subtitle?.seed : 'Random' }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'custom'">
          <span class="cp-palhero-l1">Custom Theme</span>
          <span class="cp-palhero-l2">Source: <span class="cp-palhero-em">{{ subtitle?.seed ? 'seed-' + subtitle?.seed : 'Custom' }}</span></span>
        </ng-container>
      </span>
    </div>
    <div class="cp-palhero-actions">
      <span class="cp-palhero-init-label">Quick Start</span>
      <div class="cp-palhero-init-row">
        <div class="cp-palhero-field cp-palhero-field-gen" *ngIf="!studio">
          <label class="cp-palhero-field-label" [attr.for]="fileInputId + '-gen'">Generator</label>
          <app-cg-select class="cp-palhero-select-wrap" [options]="generatorOptions"
                         [value]="selectedScheme" placeholder="Select Generator"
                         (valueChange)="onSchemeChange( $event )" ariaLabel="Generator"></app-cg-select>
        </div>

        <!-- The palette tool's generator (owner 2026-10-12): the shared visual picker -->
        <app-generator-picker class="cp-palhero-field ps-gen" *ngIf="studio"
                              [scheme]="selectedScheme" [themeKey]="selectedTheme"
                              (schemeChange)="onSchemeChange( $event )" (themeChange)="selectedTheme = $event"></app-generator-picker>
        <div class="ps-rest">
        <div class="cp-palhero-field cp-palhero-field-range">
          <label class="cp-palhero-field-label" [attr.for]="fileInputId + '-range'">
            Range <span class="cp-palhero-field-hint">{{ countDisabled ? '(10)' : '(' + countMin + '-10)' }}</span>
          </label>
          <span class="cp-palhero-count-wrap">
            <input [id]="fileInputId + '-range'" type="text" class="cp-palhero-count-input"
                   inputmode="numeric" maxlength="2"
                   [value]="count" [disabled]="countDisabled"
                   [title]="countDisabled ? 'Codigrate Themes always use 10 colors' : 'Between ' + countMin + ' and 10'"
                   (input)="onCountInput( $any( $event.target ) )"
                   (blur)="onCountCommit( $any( $event.target ) )"
                   [attr.aria-label]="'Number of colors, between ' + countMin + ' and 10'"/>
            <span class="cp-palhero-stepper">
              <button type="button" class="cp-palhero-step" tabindex="-1" aria-label="Increase"
                      [disabled]="countDisabled || count >= 10"
                      (pointerdown)="startStep( 1 )" (pointerup)="stopStep()"
                      (pointerleave)="stopStep()" (pointercancel)="stopStep()">
                <svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 5 4.5 1.5a0.7 0.7 0 0 1 1 0L9 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <button type="button" class="cp-palhero-step" tabindex="-1" aria-label="Decrease"
                      [disabled]="countDisabled || count <= countMin"
                      (pointerdown)="startStep( -1 )" (pointerup)="stopStep()"
                      (pointerleave)="stopStep()" (pointercancel)="stopStep()">
                <svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1 4.5 4.5a0.7 0.7 0 0 0 1 0L9 1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </span>
          </span>
        </div>
        <button type="button" class="cp-palhero-btn cp-palhero-generate"
                [disabled]="!canGenerate" (click)="onGenerateClick()">
          <app-icon class="cp-palhero-generate-icon" [name]="selectedScheme === 'image' ? 'upload' : 'rotate'" aria-hidden="true"></app-icon>
          {{ selectedScheme === 'image' ? 'Upload' : 'Generate' }}
        </button>
        </div>
      </div>
    </div>
  </div>

  <!-- The palette: each colour is a tile (the swatch is the picker) with an
       editable hex below and a hover delete. A trailing "+" tile adds a colour.
       Drag a swatch to reorder. -->
  <div class="cp-palhero-list" *ngIf="showTiles" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="reorder.emit( $event )">
    <div class="cp-tile" *ngFor="let color of palette; index as i" cdkDrag>
      <div class="cp-tile-swatch" [class.active]="selIdx === i" [style.background-color]="color.value" cdkDragHandle
           role="button" (click)="selectTile( i )" (dblclick)="removeColor.emit( i )"
           [attr.aria-label]="'Color ' + ( i + 1 ) + ', click to select, double-click to remove'"></div>
      <span class="cp-tile-hexlabel">{{ color.value }}</span>

      <div *cdkDragPreview class="cp-tile-preview" [style.background-color]="color.value"></div>
      <div *cdkDragPlaceholder class="cp-tile-placeholder" [style.background-color]="color.value"></div>
    </div>

    <button type="button" class="cp-tile-add" *ngIf="palette.length < 10" (click)="addColor.emit()" aria-label="Add color">
      <app-icon name="plus" aria-hidden="true"></app-icon>
    </button>
  </div>

  <!-- Editor for the selected colour (same pattern as the gradient tool's stop
       panel): a Color field with a hex input + swatch picker. -->
  <div class="cp-palhero-edit">
    <div class="cp-edit-field">
      <span class="cp-edit-label">Color</span>
      <div class="cp-edit-row">
        <label class="cp-edit-control">
          <input #cx type="text" class="cp-edit-input"
                 [value]="selectedHexLabel"
                 (input)="onHexInput( $any( $event.target ) )"
                 (keydown.enter)="cx.blur()"
                 (blur)="commitSelectedHex( cx.value ); cx.value = selectedHexLabel"
                 maxlength="7" spellcheck="false" autocomplete="off" autocapitalize="off"
                 aria-label="Selected color"/>
          <span class="cp-edit-swatch" [style.background]="selectedColor">
            <input type="color" class="cp-edit-swatch-pick" [value]="selectedColor"
                   (input)="onPick( selIdx, $any( $event.target ).value )" aria-label="Pick color"/>
          </span>
        </label>
        <button type="button" class="cp-edit-remove" (click)="removeSelected()"
                [disabled]="palette.length <= 3" aria-label="Remove color">
          <app-icon name="trash" aria-hidden="true"></app-icon>
        </button>
        <button type="button" class="cp-edit-remove cp-edit-reverse" (click)="reverseColors()"
                [disabled]="palette.length < 2" aria-label="Reverse the colors" title="Reverse the colors">
          <app-icon name="right-left" aria-hidden="true"></app-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<input [id]="fileInputId" class="cp-palhero-file" type="file" (change)="uploadImage.emit( $event )" accept="image/*"/>

<!-- Home page: a read-more style CTA to the full palette tool. -->
<div *ngIf="showDetailsCta" class="cw-cta-row">
  <a class="codigrate-button" [routerLink]="detailsRoute" [queryParams]="detailsQueryParams">
    <app-arrow-right [height]="16"></app-arrow-right>
    <p>Open Full Palette Tool</p>
  </a>
</div>
